export function isReferrerValid(referrers: string[]): boolean {
    const domain = _getReferrerDomain();
    const isFromCheckout = document.referrer === `${document.location.origin}/panier`;
    return !(
        (referrers && !domain) ||
        (referrers && domain && !(referrers.some((r) => domain.includes(r)) || isFromCheckout))
    );
}

function _getReferrerDomain(): string | null {
    const url = document.referrer ? new URL(document.referrer) : null;
    return url?.hostname || null;
}
